module.exports = __webpack_public_path__ + "img/coupon_bg_04.b89f7a8a.jpg";